import Order from "features/Order/OrderList/Order";

const OrderPage: React.FC = () => {
  return <Order />;
};

export default OrderPage;
